import React, { Component } from 'react';
import CategoryListing from '../../components/CategoryListing/CategoryListing';

class CategoriesPage extends Component {
  state = {};
  render() {
    return (
      <div
        style={{
          textAlign: 'center',
          backgroundSize: 'cover',
          minWidth: '100%',
          minHeight: '100%',
          width: '100vh',
          height: '100vh',
          backgroundColor: '#DAD4C4',
          margin: '0',
        }}
      >
        <h1 style={{ marginTop: '0', paddingTop: '10%' }}>What do you want to do today?</h1>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'flex-end',
          }}
        >
          <CategoryListing type='goal' />
          <CategoryListing type='habit' />
          <CategoryListing type='budget' />
        </div>
      </div>
    );
  }
}

export default CategoriesPage;
